export default {
  PREV: "PREV",
  NEXT: "NEXT",
  START: "flex-start",
  CENTER: "center",
  END: "flex-end"
};

//Actions
export const NEXT_ITEM = "NEXT_ITEM";
export const PREV_ITEM = "PREV_ITEM";
